import { Image as ChakraImage, ImageProps } from "@chakra-ui/image";
import { DEFAULT_IMAGE_FALLBACK } from "../../constant/placeholders";

function Image(props: ImageProps) {
  return <ChakraImage fallbackSrc={DEFAULT_IMAGE_FALLBACK} {...props} />;
}

export default Image;
